import { CustomSearchXStoreModule } from '../types';

// eslint-disable-next-line max-len
export const saveExtraResultsResponse: CustomSearchXStoreModule['actions']['saveExtraResultsResponse'] =
  ({ commit }, { results }) => {
    if (results) {
      commit('setExtraResults', results);
    }
  };
